import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { SITE } from "../data/site";

export const CtaBand = ({ title, text }) => {
  return (
    <section className="bg-forest text-ivory py-16 md:py-24" data-testid="cta-band">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl sm:text-5xl font-medium tracking-tight">
          {title || "Let's make this easier."}
        </h2>
        <p className="mt-5 text-base sm:text-lg text-ivory/80 leading-relaxed max-w-2xl mx-auto">
          {text ||
            "Tell us about the property and what you're facing. We'll listen, walk you through the options, and give you a clear written quote — no pressure, no obligation."}
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/contact" className="btn-brass" data-testid="cta-band-quote-button">
            Request a Quote
          </Link>
          <a href={SITE.phoneHref} className="btn-outline-light" data-testid="cta-band-call-button">
            <Phone className="w-4 h-4" />
            Call {SITE.phone}
          </a>
        </div>
        <p className="mt-6 text-xs uppercase tracking-[0.2em] text-ivory/50">Serving {SITE.serviceArea}</p>
      </div>
    </section>
  );
};
